import { Box, CircularProgress, TableCell, TableRow } from '@mui/material';
import VirtualizedTableNoResults from '../noResults/VirtualizedTableNoResults';
import { VirtualizedTableFooterProps } from './types/virtualizedTableFooter.types';

const VirtualizedTableFooter = ({
  colSpan,
  dataLength,
  isLoadingNextPage,
}: VirtualizedTableFooterProps) => {
  if (!isLoadingNextPage && !!dataLength) {
    return null;
  }

  if (!dataLength) {
    return (
      <TableRow>
        <TableCell padding="none" colSpan={colSpan}>
          <Box
            sx={{
              position: 'sticky',
              left: '50%',
              width: 'fit-content',
              transform: 'translateX(-50%)',
            }}
          >
            <VirtualizedTableNoResults />
          </Box>
        </TableCell>
      </TableRow>
    );
  }

  return (
    <TableRow>
      <TableCell padding="none" colSpan={colSpan}>
        <CircularProgress
          size={16}
          style={{
            position: 'sticky',
            left: '50%',
          }}
        />
      </TableCell>
    </TableRow>
  );
};

export default VirtualizedTableFooter;
